import { render, staticRenderFns } from "./userRegister.vue?vue&type=template&id=426b69eb&scoped=true"
import script from "./userRegister.vue?vue&type=script&lang=js"
export * from "./userRegister.vue?vue&type=script&lang=js"
import style0 from "./userRegister.vue?vue&type=style&index=0&id=426b69eb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426b69eb",
  null
  
)

export default component.exports